export const navData = [
    { url: 'https://rukminim1.flixcart.com/fk-p-flap/128/128/image/1350e22cff9663e7.png?q=100', text: 'Top Offers' },
    { url: 'https://img.bookchor.com/bookchor/app-media/2024022297458.webp', text: 'Fiction' },
    { url: 'https://img.bookchor.com/bookchor/app-media/2024022273761.webp', text: 'Non-Fiction' },
    { url: 'https://img.bookchor.com/bookchor/app-media/2024022270201.webp', text: 'Children' },
    { url: 'https://img.bookchor.com/bookchor/app-media/2024022272900.webp', text: 'Text Books' },
    { url: 'https://iili.io/dK7b9II.png', text: 'Comics' },
    { url: 'https://iili.io/dK7pLB9.png', text: 'Health' },
    { url: 'https://iili.io/dK7pROQ.png', text: 'Languages' },
    // { url: 'https://rukminim1.flixcart.com/fk-p-flap/128/128/image/46376ceed3448aff.png?q=100', text: 'Grocery' }
];

export const bannerData = [
    { id: 1, url: 'https://d34a0mln2492j4.cloudfront.net/unsigned/resize:fit:2880:700:0/gravity:sm/plain/https%3A%2F%2Fs3-ap-south-1.amazonaws.com%2Fbookscape-s3-bucket%2F52DADD2615Disney_Home_Page_Hero_Banner_Desktop_(1).jpg' },
    { id: 2, url: 'https://d34a0mln2492j4.cloudfront.net/unsigned/resize:fit:2880:700:0/gravity:sm/plain/https%3A%2F%2Fs3-ap-south-1.amazonaws.com%2Fbookscape-s3-bucket%2F8DC6D2CF47Young_Adult_3.png' },
    { id: 3, url: 'https://d34a0mln2492j4.cloudfront.net/unsigned/resize:fit:2880:700:0/gravity:sm/plain/https%3A%2F%2Fs3-ap-south-1.amazonaws.com%2Fbookscape-s3-bucket%2FEA4B2A260CYoung_Adult_2.png' },
    { id: 4, url: 'https://d34a0mln2492j4.cloudfront.net/unsigned/resize:fit:2880:700:0/gravity:sm/plain/https%3A%2F%2Fs3-ap-south-1.amazonaws.com%2Fbookscape-s3-bucket%2F5B57C38873Young_Adult_1.png' },
    { id: 5, url: 'https://d34a0mln2492j4.cloudfront.net/unsigned/resize:fit:2880:700:0/gravity:sm/plain/https%3A%2F%2Fs3-ap-south-1.amazonaws.com%2Fbookscape-s3-bucket%2F59C61A465CHero_Banner_1D.jpg' },
    { id: 6, url: 'https://d34a0mln2492j4.cloudfront.net/unsigned/resize:fit:2880:700:0/gravity:sm/plain/https%3A%2F%2Fs3-ap-south-1.amazonaws.com%2Fbookscape-s3-bucket%2F4D526A6A93Science_%26_Fun_D.jpg' },
    // { id: 7, url: 'https://rukminim2.flixcart.com/fk-p-flap/3300/560/image/3f678a35c5eebd8f.png?q=50' },
    // { id: 8, url: 'https://rukminim1.flixcart.com/flap/3376/560/image/ae9966569097a8b7.jpg?q=50' }

    
]

export const productsData = [
    {
      id: "product1",
      url: "https://d34a0mln2492j4.cloudfront.net/unsigned/resize:fit:288:400:0/gravity:sm/plain/https%3A%2F%2Fbookscape-s3-bucket.s3.amazonaws.com%2Fproduct_images%2F9789395483247.jpg",
      detailUrl:
        "https://d34a0mln2492j4.cloudfront.net/unsigned/resize:fit:288:400:0/gravity:sm/plain/https%3A%2F%2Fbookscape-s3-bucket.s3.amazonaws.com%2Fproduct_images%2F9781642021677.jpg",
      title: {
        shortTitle: "Modi@20",
        longTitle: "Modi@20",
      },
      price: {
        mrp: 625,
        cost: 562,
        discount: "47%",
      },
      quantity: 1,
      description:
        "Modi@20 Book.",
      discount: "Extra 10% Off",
      tagline: "Deal of the day",
    },
    {
      id: "product2",
      url: "https://d34a0mln2492j4.cloudfront.net/unsigned/resize:fit:288:400:0/gravity:sm/plain/https%3A%2F%2Fbookscape-s3-bucket.s3.amazonaws.com%2Fproduct_images%2F9781642021677.jpg",
      detailUrl:
        "https://d34a0mln2492j4.cloudfront.net/unsigned/resize:fit:288:400:0/gravity:sm/plain/https%3A%2F%2Fbookscape-s3-bucket.s3.amazonaws.com%2Fproduct_images%2F9781642021677.jpg",
      title: {
        shortTitle: "My Name Is Alison",
        longTitle: "My Name Is Alison: An Urban Fantasy Action Adventure: 3 (Alison Brownstone)",
      },
      price: {
        mrp: 899,
        cost: 599,
        discount: "40%",
      },
      quantity: 1,
      description:
        "My Name Is Alison: An Urban Fantasy Action Adventure: 3 (Alison Brownstone). ",
      discount: "From 99+5% Off",
      tagline: "Pestige, Nova & more",
    },
    {
      id: "product3",
      url: "https://d34a0mln2492j4.cloudfront.net/unsigned/resize:fit:760:1000:0/gravity:sm/plain/https%3A%2F%2Fbookscape-s3-bucket.s3.amazonaws.com%2Fproduct_images%2F9780692162682.jpg",
      detailUrl:
        "https://d34a0mln2492j4.cloudfront.net/unsigned/resize:fit:760:1000:0/gravity:sm/plain/https%3A%2F%2Fbookscape-s3-bucket.s3.amazonaws.com%2Fproduct_images%2F9780692162682.jpg",
      title: {
        shortTitle: "Out of Darkness",
        longTitle:
          "Out of Darkness shared By M A Richards",
      },
      price: {
        mrp: 499,
        cost: 366,
        discount: "66%",
      },
      quantity: 1,
      description:
        "Out of Darkness shared By M A Richards.",
      discount: "Upto 70% Off",
      tagline: "Deal of the Day",
    },
    {
      id: "product4",
      url: "https://d34a0mln2492j4.cloudfront.net/unsigned/resize:fit:760:1000:0/gravity:sm/plain/https%3A%2F%2Fbookscape-s3-bucket.s3.amazonaws.com%2Fproduct_images%2F9788183227001.jpg",
      detailUrl:
        "https://d34a0mln2492j4.cloudfront.net/unsigned/resize:fit:760:1000:0/gravity:sm/plain/https%3A%2F%2Fbookscape-s3-bucket.s3.amazonaws.com%2Fproduct_images%2F9788183227001.jpg",
      title: {
        shortTitle: "The 1% Solution- for Work and Life",
        longTitle: "The 1% Solution- for Work and Life",
      },
      price: {
        mrp: 999,
        cost: 889,
        discount: "42%",
      },
      quantity: 1,
      description:
        "The 1% Solution- for Work and Life.",
      discount: "Grab Now",
      tagline: "Best Seller",
    },
    {
      id: "product5",
      url: "https://d34a0mln2492j4.cloudfront.net/unsigned/resize:fit:760:1000:0/gravity:sm/plain/https%3A%2F%2Fbookscape-s3-bucket.s3.amazonaws.com%2Fproduct_images%2F9789355995001.jpg",
      detailUrl:
        "https://d34a0mln2492j4.cloudfront.net/unsigned/resize:fit:760:1000:0/gravity:sm/plain/https%3A%2F%2Fbookscape-s3-bucket.s3.amazonaws.com%2Fproduct_images%2F9789355995001.jpg",
      title: {
        shortTitle: "Ikigai ",
        longTitle: "Ikigai : Japanese Art of staying Young.. While growing Old",
      },
      price: {
        mrp: 799,
        cost: 624,
        discount: "40%",
      },
      quantity: 1,
      description: "Ikigai : Japanese Art of staying Young.. While growing Old",
      discount: "From ₹499",
      tagline: "Kubra, Nova & more",
    },
    {
      id: "product6",
      url: "https://d34a0mln2492j4.cloudfront.net/unsigned/resize:fit:760:1000:0/gravity:sm/plain/https%3A%2F%2Fbookscape-s3-bucket.s3.amazonaws.com%2Fproduct_images%2F9781612681139.jpg",
      detailUrl:
        "https://d34a0mln2492j4.cloudfront.net/unsigned/resize:fit:760:1000:0/gravity:sm/plain/https%3A%2F%2Fbookscape-s3-bucket.s3.amazonaws.com%2Fproduct_images%2F9781612681139.jpg",
      title: {
        shortTitle: "Rich Dad Poor Dad",
        longTitle:
          "Rich Dad Poor Dad",
      },
      price: {
        mrp: 890,
        cost: 720,
        discount: "46%",
      },
      quantity: 1,
      description:
        'Rich Dad Poor Dad , shared What the Rich Teach Their Kids About Money That the Poor and Middle Class Do Not! By Robert T. Kiyosaki ',
      discount: "Minimum 40% Off",
      tagline: "Top Selling",
    },
    {
      id: "product7",
      url: "https://d34a0mln2492j4.cloudfront.net/unsigned/resize:fit:760:1000:0/gravity:sm/plain/https%3A%2F%2Fimage-hub.reproindialtd.com%2F9798890665867.jpg",
      detailUrl:
        "https://d34a0mln2492j4.cloudfront.net/unsigned/resize:fit:760:1000:0/gravity:sm/plain/https%3A%2F%2Fimage-hub.reproindialtd.com%2F9798890665867.jpg",
      title: {
        shortTitle: "Money Mindsets",
        longTitle:
          "Money Mindset: Science-Based Stories to Rewire your Money Beliefs Goals & Habits ",
      },
      price: {
        mrp: 690,
        cost: 599,
        discount: "59%",
      },
      quantity: 1,
      description:
        "Money Mindset: Science-Based Stories to Rewire your Money Beliefs Goals & Habits.",
      discount: "Minimum 50% Off",
      tagline: "Grab Now!",
    },
  ];

export const dealData = [
    { 
        id: 'product0',
        url: 'https://rukminim1.flixcart.com/image/200/200/khf63680/cases-covers/back-cover/d/7/g/spigen-acs02256-original-imafxfgbffqaugur.jpeg?q=70', 
        detailUrl: '',
        title: {
            shortTitle: 'Mobile Covers'
        }, 
        discount: 'Extra 10% Off', 
        tagline: 'Deal of the day' 
    },
    { 
        id: 'product2',
        url: 'https://rukminim1.flixcart.com/image/200/200/k5lcvbk0/moisturizer-cream/9/w/g/600-body-lotion-aloe-hydration-for-normal-skin-nivea-lotion-original-imafz8jb3ftt8gf9.jpeg?q=70', 
        title: {
            shortTitle: 'Skin & Hair Care'
        },
        discount: 'From 99+5% Off', 
        tagline: 'Shampoos, Face Washes & More' 
    },
    { 
        id: 'product3',
        url: 'https://rukminim1.flixcart.com/flap/200/200/image/74bc985c62f19245.jpeg?q=70', 
        title: {
            shortTitle: 'Skybags & Safari'
        }, 
        discount: 'Upto 70% Off', 
        tagline: 'Deal of the Day' 
    },
    { 
        id: 'product4',
        url: 'https://rukminim1.flixcart.com/image/300/300/kll7bm80/smartwatch/c/1/n/43-mo-sw-sense-500-android-ios-molife-original-imagyzyycnpujyjh.jpeg?q=70', 
        detailUrl: 'https://rukminim1.flixcart.com/image/416/416/kll7bm80/smartwatch/c/1/n/43-mo-sw-sense-500-android-ios-molife-original-imagyzyycnpujyjh.jpeg?q=70',
        title: {
            shortTitle: 'Smart Watches',
            longTitle: 'Molife Sense 500 Smartwatch  (Black Strap, Freesize)',
        }, 
        price: {
            mrp: 6999,
            cost: 4049,
            discount: '42%'
        },
        description: 'The Molife Sense 500, a brilliant smartwatch with a beautiful large display. Say hello to the infinity 1.7-inch display with 2.5D curved edges. Thanks to seamless Bluetooth 5.0 connectivity, you wont have to keep waiting. Bring a change to your outfit every day with changeable straps. A splash of color every day keeps the boredom away.',
        discount: 'Grab Now', 
        tagline: 'Best Seller' 
    },
    { 
        id: 'product5',
        url: 'https://rukminim1.flixcart.com/flap/150/150/image/b616a7aa607d3be0.jpg?q=70', 
        title: {
            shortTitle: 'Sports & Fitness Essentials'
        }, 
        discount: 'Upto 80% Off', 
        tagline: 'Ab Exerciser, Yoga & more' 
    }
];

export const furnitureData = [
    { 
        url: 'https://rukminim1.flixcart.com/image/300/300/ke7ff680/hammock-swing/j/f/u/q3-jkaf-y3l0-furniture-kart-original-imafux96kpy7grch.jpeg?q=70', 
        title: {
            shortTitle: 'Hammock And Swings'
        }, 
        discount: 'From ₹199', 
        tagline: 'Trendy Collection' 
    },
    { 
        url: 'https://rukminim1.flixcart.com/image/300/300/bean-bag/h/v/b/f8-the-furniture-store-xxxl-original-imae65d3wg7qzpkn.jpeg?q=70', 
        title: {
            shortTitle: 'Bean Bag Covers'
        }, 
        discount: 'Min 80% Off', 
        tagline: 'XL, XXL & More' 
    },
    { 
        url: 'https://rukminim1.flixcart.com/image/300/300/jlcmavk0/aquarium-tank/s/4/5/usb-desktop-aquarium-with-running-water-calendar-temperature-and-original-imaf8hv4nkv55gx8.jpeg?q=70', 
        title: {
            shortTitle: 'Aquarium Tank'
        }, 
        discount: 'From ₹299', 
        tagline: 'Flat, Round, Cube & More' 
    },
    { 
        url: 'https://rukminim1.flixcart.com/image/300/300/jffpoy80/office-study-chair/v/v/z/pp-am-5001cb-apex-original-imaf3u8rbr5cdycv.jpeg?q=70', 
        title: {
            shortTitle: 'Office & Study Chairs'
        }, 
        discount: 'Min 50% Off', 
        tagline: 'Fabric & Leatherette' 
    },
    { 
        url: 'https://rukminim1.flixcart.com/image/300/300/jvcp9jk0/recliner/z/w/x/brown-top-grain-leather-sf7018011-1-royaloak-original-imafg9s9hh9vzpf3.jpeg?q=70', 
        title: {
            shortTitle: 'Recliner'
        }, 
        discount: 'From ₹4999', 
        tagline: 'Bantia, RoyalOak & More' 
    },
    { 
        url: 'https://rukminim1.flixcart.com/image/300/300/jlqwpe80-1/tv-entertainment-unit/d/t/f/particle-board-holland-tv-unit-black-forzza-black-original-imaf8t5ybywcdtys.jpeg?q=70', 
        title: {
            shortTitle: 'Tv Units'
        }, 
        discount: 'From ₹2100', 
        tagline: 'Forzza, Zuari & more' 
    },
    { 
        url: 'https://rukminim1.flixcart.com/image/300/300/inflatable-sofa/6/j/s/wsb031a-velvet-wds-original-imaeaphzbkgrz3xp.jpeg?q=70', 
        title: {
            shortTitle: 'Inflatable Sofas'
        }, 
        discount: 'Min 50% Off', 
        tagline: 'Furn Central & more' 
    },
];